import { render } from "./UnitTable.vue?vue&type=template&id=2ffd9dbb&scoped=true"
import script from "./UnitTable.vue?vue&type=script&lang=js"
export * from "./UnitTable.vue?vue&type=script&lang=js"

import "./UnitTable.vue?vue&type=style&index=0&id=2ffd9dbb&lang=scss"
import "./UnitTable.vue?vue&type=style&index=1&id=2ffd9dbb&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffd9dbb"]])

export default __exports__